// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-list {

}

.dropdown-list .dropdown-list__content {
	position: relative;
	top: -4px;
}

.dropdown-list .dropdown-list__preview {
	position: relative;
	top: 4px;
	left: 4px;
	z-index: 201;
}

.dropdown-list .dropdown-list__dropdown {
	display: none;
	position: absolute;
	top: 0;
	z-index: 200;
	margin: 0;
	padding: 32px 0 0 0;
	border-radius: 6px;
	background-color: #fff;
	border: #ddd 1px solid;
	overflow: hidden;
	list-style: none;
}

.dropdown-list .dropdown-list__dropdown-item {
	min-width: 240px;
	padding: 9px 6px;
	cursor: pointer;
}

.dropdown-list .dropdown-list__dropdown-item:hover {
	background-color: #ddd;
}

.dropdown-list .dropdown-list__content:hover .dropdown-list__dropdown {
	display: block;
}

.dropdown-list .dropdown-list__content .dropdown-list__dropdown:hover {
	display: block;
}
`, "",{"version":3,"sources":["webpack://./src/css/components/HoverDropdownList/HoverDropdownList.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;AACb;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,YAAY;CACZ,SAAS;CACT,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;CACtB,sBAAsB;CACtB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf","sourcesContent":[".dropdown-list {\n\n}\n\n.dropdown-list .dropdown-list__content {\n\tposition: relative;\n\ttop: -4px;\n}\n\n.dropdown-list .dropdown-list__preview {\n\tposition: relative;\n\ttop: 4px;\n\tleft: 4px;\n\tz-index: 201;\n}\n\n.dropdown-list .dropdown-list__dropdown {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 200;\n\tmargin: 0;\n\tpadding: 32px 0 0 0;\n\tborder-radius: 6px;\n\tbackground-color: #fff;\n\tborder: #ddd 1px solid;\n\toverflow: hidden;\n\tlist-style: none;\n}\n\n.dropdown-list .dropdown-list__dropdown-item {\n\tmin-width: 240px;\n\tpadding: 9px 6px;\n\tcursor: pointer;\n}\n\n.dropdown-list .dropdown-list__dropdown-item:hover {\n\tbackground-color: #ddd;\n}\n\n.dropdown-list .dropdown-list__content:hover .dropdown-list__dropdown {\n\tdisplay: block;\n}\n\n.dropdown-list .dropdown-list__content .dropdown-list__dropdown:hover {\n\tdisplay: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
